<div id="head"></div>
<h1 class="sr-only">Color Blindness Simulator - See Any Image As People With Color Blindness Do</h1>

<!-- ===================== Hero: the simulator itself ===================== -->
<div class="default-section initial-section metallic-section no-buttons wp-hero" data-section="top">
  <div class="cp-hero-head">
    <p class="tools-title" aria-hidden="true">Color Blindness Simulator</p>
    <p class="tools-subtitle">{{ subtitle }}</p>
  </div>

  <app-cvd-widget [src]="startSrc" (stateChange)="onState( $event )"></app-cvd-widget>
</div>

<nav class="cp-chipbar" appStuck aria-label="Color blindness simulator sections">
  <div class="cp-chipbar-row">
    <a *ngFor="let s of pageSections" class="pl-chip" [class.on]="activeSection === s.key" [attr.href]="'#sec-' + s.key"
       (click)="$event.preventDefault(); scrollToSection( s.key )">
      <span>{{ s.label }}</span>
    </a>
  </div>
</nav>

<div class="cp-body cp-boxes">
  <div class="cp-content">

    <!-- All Simulations: the picture through every condition at once -->
    <section class="cp-section" id="sec-all" data-section="all">
      <header class="cp-head">
        <h2 class="cp-h2">All Simulations</h2>
        <p class="cp-section-lead">Your picture through all eight color vision deficiencies, side by side</p>
      </header>
      <div class="cp-main">
        <div class="cv-grid">
          <figure class="cv-item" *ngFor="let t of thumbs; let i = index">
            <button class="cv-frame" type="button" (click)="openLightbox( i )" [attr.aria-label]="'Enlarge ' + t.name"><img [src]="t.url" [alt]="'The picture with ' + t.name" decoding="async"/></button>
            <figcaption class="cp-cv-cap"><span class="cp-cv-name">{{ t.name }}:</span> <span class="cp-cv-desc">{{ t.note }}. {{ t.share }}</span></figcaption>
          </figure>
        </div>
      </div>
    </section>

    <!-- Lightbox: the theme pages' (src/styles/page/tool-lightbox.scss). One simulation at full size over a frosted
         backdrop and one pill under it: previous, the condition, next, close. Arrow keys page, Escape closes. -->
    <div class="cp-lightbox" *ngIf="lightboxIndex !== null" role="dialog" aria-modal="true" [attr.aria-label]="thumbs[ lightboxIndex ].name" (click)="closeLightbox()">
      <figure class="cp-lightbox-inner" (click)="$event.stopPropagation()">
        <img [src]="lightboxUrl || thumbs[ lightboxIndex ].url" [alt]="'The picture with ' + thumbs[ lightboxIndex ].name">
      </figure>
      <div class="cp-lightbox-caption-row" (click)="$event.stopPropagation()">
        <button class="cp-lb-seg cp-lb-nav" type="button" (click)="stepLightbox( -1 )" aria-label="Previous simulation">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 4.5 L7.5 12 L15 19.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
        </button>
        <span class="cp-lb-seg td-lb-label">
          <span class="cp-lb-name">
            <span class="cp-lb-name-sizer" *ngFor="let t of thumbs" aria-hidden="true">{{ t.name }}</span>
            <span class="cp-lb-name-cur">{{ thumbs[ lightboxIndex ].name }}</span>
          </span>
        </span>
        <button class="cp-lb-seg cp-lb-nav" type="button" (click)="stepLightbox( 1 )" aria-label="Next simulation">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 4.5 L16.5 12 L9 19.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
        </button>
        <button class="cp-lb-seg cp-lb-close" type="button" (click)="closeLightbox()" aria-label="Close">&times;</button>
      </div>
    </div>

    <!-- More Color Tools (owner 2026-10-22): the Color Picker, above How It Works -->
    <app-more-tools sectionKey="more" title="More Color Tools" lead="Pick any color on your screen and read it the same way, right from your menu bar"
                    [app]="colorPicker" [source]="moreToolsSource"></app-more-tools>

    <app-tool-about [lead]="aboutLead" [paragraphs]="aboutParagraphs" [faq]="faq" ratingKey="color-blindness-simulator" ratingName="the Color Blindness Simulator"></app-tool-about>
  </div>
</div>
